import { number, string } from 'prop-types';
import React from 'react';
import { Label } from 'reactstrap';

import getInfoTooltip from './get-info-tooltip';

export default function getTooltipLabelWithText(helpTexts) {
  function TooltipLabel({
    helpKey,
    text,
    colWidth,
    resource,
    section,
    placement,
    id = `${resource}-${helpKey}`,
    ...rest
  }) {
    return (
      <Label sm={colWidth} for={id} {...rest}>
        {text}
        {getInfoTooltip(helpTexts, helpKey, section, placement)}
      </Label>
    );
  }

  TooltipLabel.propTypes = {
    helpKey: string.isRequired,
    text: string.isRequired,
    colWidth: number,
    resource: string,
    section: string,
    placement: string,
    id: string,
  };

  TooltipLabel.defaultProps = {
    resource: 'qu',
    section: 'budgetDetails',
    id: undefined,
    colWidth: undefined,
    placement: undefined,
  };

  return TooltipLabel;
}
